// extracted by mini-css-extract-plugin
export default {"container":"PriceList_container__+49wD","wrapper":"PriceList_wrapper__xsk7L","footerStyle":"PriceList_footerStyle__lSxi+"};